import api from './api';
import { SystemStats } from '../types';

// Helper function to check if it's a network error
const isNetworkError = (error: any): boolean => {
  return !error.response && (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error') || error.message?.includes('ERR_NETWORK'));
};

export const systemApi = {
  // Get system health (using new /health endpoint)
  getSystemHealth: async (): Promise<any> => {
    try {
      const response = await api.get('/health');
      return {
        status: response.data.status || 'healthy',
        uptime: response.data.uptime || 'N/A',
        response_time: response.data.response_time || 'N/A',
        database: {
          status: response.data.database?.status || 'connected',
          response_time: response.data.database?.response_time || 'N/A'
        },
        api: {
          status: response.data.api?.status || 'operational',
          version: response.data.api?.version || '1.0.0'
        },
        last_check: new Date().toISOString()
      };
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to connect to server. Please check your internet connection.');
      }
      throw error;
    }
  },

  // Get system statistics
  getSystemStats: async (): Promise<SystemStats> => {
    try {
      const response = await api.get('/admin/stats');
      return response.data;
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to connect to server. Please check your internet connection.');
      }
      throw new Error(error.response?.data?.detail || 'Failed to fetch system stats');
    }
  },

  // Get API root information
  getApiInfo: async (): Promise<any> => {
    try {
      const response = await api.get('/');
      return response.data;
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to connect to server. Please check your internet connection.');
      }
      throw error;
    }
  },

  // Notifications (placeholder endpoints; adjust to your backend)
  getNotifications: async (): Promise<any[]> => {
    try {
      const response = await api.get('/notifications');
      return response.data?.notifications || [];
    } catch (error: any) {
      if (isNetworkError(error)) {
        throw new Error('Unable to load notifications. Check your connection.');
      }
      throw error;
    }
  },
  markNotificationRead: async (id: string): Promise<void> => {
    await api.post(`/notifications/${id}/read`);
  },
  markAllRead: async (): Promise<void> => {
    await api.post('/notifications/read-all');
  },
};
